import { styled } from '@mui/material';

const PREFIX = 'withChart';

export const classes = {
  root: `${PREFIX}-root`,
  iconContainer: `${PREFIX}-iconContainer`,
};

export const Root = styled('div')(() => ({
  [`&.${classes.root}`]: {
    position: 'relative',
    width: '100%',
    minHeight: '100%',
    display: 'flex',
    alignItems: 'center',
  },

  [`& .${classes.iconContainer}`]: {
    position: 'absolute',
    left: 2,
    top: '50%',
    transform: 'translateY(-50%)',
    opacity: 0,
    zIndex: 1,
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    transition: 'opacity 0.2s ease, transform 0.2s ease, filter 0.2s ease',
    padding: 0,
    background: 'none',
    border: 'none',
    borderRadius: '50%',
    '&:hover': {
      transform: 'translateY(-50%) scale(1.2)',
      filter: 'drop-shadow(0 0 4px rgba(82, 163, 255, 0.6))',
    },
  },

  'td:hover &': {
    [`& .${classes.iconContainer}`]: {
      opacity: 1,
    },
  },
}));
